import { action } from 'satcheljs/lib/legacy';
import { default as getNotesSDK } from '../utils/getNotesSDK';
import getStore from '../store/store';
export default action('deleteNote')(function deleteNote() {
    getNotesSDK().deleteNote(getStore().selectedNoteId);
});
